import { Button, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import GenerateIcon, { IconTypes } from '../../components/GenerateIcon'
import ItemsApp, { IItemModel } from './ItemsApp'
import { useReturnSingleDispplayer } from '../../components/DataDisplayer/dataDisplyerSlice'
import { returnSingleItemDetailsFromList, useReturnAllItems } from './itemsSlice'
import { useNavigate } from 'react-router-dom'
import { IDataDisplyerItemActionOption } from '../../components/DataDisplayer/DataDisplayer'
import { replaceItemDataInLink } from '../BaseApp'
import ItemsListPDF from './ItemsListPDF'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import { updateGlobalLoaderStatus, updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { saveAs } from "file-saver"


interface ISingleOption {
    icon: IconTypes,
    label: string,
    onClick: () => void,
}

interface IExportOptionsProps {
    isShown?: boolean,
    hideModal: () => void,
    itemActionOptions: ISingleOption[],
}

const ExportOptions = (props: IExportOptionsProps) => {

    const navigate = useNavigate()

    const { isShown, hideModal, itemActionOptions } = props

    const baseContainerClassName: string = "data-displayer-options-modal item-options"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const menuRef = useRef<HTMLDivElement | null>(null);
  
    // Close menu if clicked outside
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            hideModal()
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    useEffect(() => {
        if (isShown){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [isShown])

    return(
        <div className={containerClassName} ref={menuRef}>
            <div className="content-of-data-displayer-options-modal">
                
                {itemActionOptions.map((option, index: number) => {

                    return(
                        <div className="item-of-data-displayer-options-modal" key={index}>
                            <div className="content-of-item-of-data-displayer-options-modal">
                                <Button onClick={() => option.onClick()} fullWidth startIcon={<GenerateIcon icon={option.icon} />} className="general-button admin-style">{option.label}</Button>
                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}

interface Props {
    showPrintPage: () => void,
    selectedItems: IItemModel[],
    showQrCodesPrintPage: () => void
}

export default function ExportItems(props: Props) {

    const dispatch = useDispatch()

    const { showPrintPage, selectedItems, showQrCodesPrintPage } = props

    const itemsApp = new ItemsApp()

    const [showOptions, setShowOptions] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [title, setTitle] = useState<string>("")
    const [details, setDetails] = useState<string>("")

    /**
     * Handle show options
     */
    const handleShowOptionsModal = () => setShowOptions(true)

    /**
     * Handle hide options
     */
    const handleHideOptionsModal = () => setShowOptions(false)

    /**
     * handle print
     */
    const handlePrint = () => {
        const elemt = document.getElementById("print-items-export-button")
        if (elemt){
            elemt.click()
        }
    }

    const getOnlyIds = (items: IItemModel[]) => {
        let ids: number[] = []

        items.map((item) => ids.push(item.id))

        return ids
    }

    /**
     * Export into excel
     */
    const exportToExcel = () => {

        dispatch(updateGlobalLoaderStatus({ status: true }));

        itemsApp.exportItems("selected_items", getOnlyIds(selectedItems))
            .then(response => {
                dispatch(updateGlobalLoaderStatus({ status: false }));
    
                const blob = response.data;
    
                const contentDisposition = response.headers["content-disposition"]
                let fileName = "exported_items.xlsx"

                console.log("contentDisposition", contentDisposition)
                console.log('response.headers', response.headers, response)

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/)
                    if (match && match[1]) {
                        fileName = match[1]
                    }
                }
    
                saveAs(blob, fileName)
    
                updateQuickNotificationDetails(true, "The items have been exported successfully!", "success", dispatch);
            })
            .catch(error => {
                dispatch(updateGlobalLoaderStatus({ status: false }));
                handleRequestError(error, dispatch);
            }); 

    }

    return(
        <>
            <div className="export-pdf-modal-container">
                <BasicModalWindow
                    shown={showModal}
                    handleClose={() => setShowModal(false)}
                    showHeader
                    title="Export as PDF"
                    size="sm"
                    actionButtons={[
                        {
                            label: "Close",
                            color: "error",
                            onClick: () => setShowModal(false)
                        },
                        {
                            label: "Export",
                            color: "success",
                            onClick: () => handlePrint(),
                            disabled: title ? false : true
                        }
                    ]}
                >
                    <div>
                        <TextField variant="outlined" label="Title" fullWidth value={title} onChange={(e) => setTitle(e.target.value)} />
                        <TextField variant="outlined" multiline minRows={5} label="Details" fullWidth value={details} onChange={(e) => setDetails(e.target.value)} style={{ marginTop: 15 }} />
                    </div>
                </BasicModalWindow>
            </div>
            <ItemsListPDF items={selectedItems} title={title} details={details} />
            <ExportOptions isShown={showOptions} hideModal={handleHideOptionsModal} itemActionOptions={[
                // {
                //     icon: "pdf",
                //     label: "PDF",
                //     onClick: () => setShowModal(true)
                // },
                {
                    icon: "print",
                    label: "Print",
                    onClick: () => showPrintPage()
                },
                {
                    icon: "qrcode",
                    label: "Qr Codes",
                    onClick: () => showQrCodesPrintPage()
                },
                {
                    icon: "document",
                    label: "Excel",
                    onClick: () => exportToExcel()
                }
            ]} />
            <Button disabled={selectedItems.length > 0 ? false : true} onClick={() => handleShowOptionsModal()} className="general-button admin-style" startIcon={<GenerateIcon icon="download" />}>
                Export
            </Button>
        </>
    )
}